import React from 'react';
import {ColorSwatch} from "@montana/shared/color-swatch";
import {IColor, IColorContentPage} from "@montana/models/generated/cms.interface";
import {RichText} from "@montana/shared/rich-text";
import {useTranslations} from "@montana/containers/translations";
import {Button} from "@montana/shared/button";

export type IColourPageSpecsModule =
    Partial<Pick<IColorContentPage, 'colorDescription' | 'surfaceDescription' | 'colorCodes' | 'colorPairing'>>
    & {
    color?: IColor;
};

function ListStrings(props: { strings: string[] }) {
    const {strings} = props;
    return (
        <ul>
            {strings.map(item => <li key={item.replace(' ', '-').toLowerCase()}>{item}</li>)}
        </ul>
    );
}

export function ColourPageSpecsModule({
                                          colorDescription,
                                          surfaceDescription,
                                          colorCodes,
                                          color
                                      }: IColourPageSpecsModule) {

    const translate = useTranslations();

    const colorSampleButtonText = translate(t => t.colorContentPage.orderColorSampleCtaText);

    return (
        <div className="color-specs-block">
            <div className="color-specs-block__content">
                {colorDescription &&
                    <RichText className="color-specs-block__content--content-p-zero-margin" text={colorDescription}/>}
                {surfaceDescription &&
                    <RichText className="color-specs-block__content--content-p-zero-margin" text={surfaceDescription}/>}
            </div>
            <div className="color-specs-block__color-container color-specs-block__content">
                <section className="color-specs-block__color-section">
                    <header
                        className="color-specs-block__section-title">{translate(t => t.colorContentPage.colorTitle)}</header>
                    <div className="color-specs-block__color-data">
                        <ColorSwatch
                            disableRowHover={true}
                            colorSwatchImage={color?.colorSwatchImage}
                            variant="row" label={color?.colorName}/>
                    </div>
                </section>
                <section className="color-specs-block__color-section">
                    <header
                        className="color-specs-block__section-title">{translate(t => t.colorContentPage.colorCodeTitle)}</header>
                    <div className="color-specs-block__color-data">
                        {colorCodes && <ListStrings strings={colorCodes}/>}
                    </div>
                </section>
                <section className="color-specs-block__color-section">
                    <header
                        className="color-specs-block__section-title">{translate(t => t.colorContentPage.surfaceQualityTitle)}</header>
                    <div className="color-specs-block__color-data">
                        {color?.surfaceLook}<br/>
                        {color?.surfaceFeel}
                    </div>
                </section>
                {/*<section className="color-specs-block__color-section">
                    <header className="color-specs-block__section-title">{translate(t => t.colorContentPage.colorParingTitle)}</header>
                    <div className="color-specs-block__color-data">
                        {colorPairing?.map((color) => (
                            <Link to={color?.link?.url} key={`colorparing-${color.colorId}`}>
                                <ColorSwatch
                                colorSwatchImage={color.colorSwatchImage}
                                variant="row" label={color.colorName}
                            /></Link>
                        ))}
                    </div>
                </section>*/}
                {!!colorSampleButtonText && colorSampleButtonText !== "Order Color Sample" && (<Button href="https://sample.montanafurniture.com/" target="_blank"
                                                   text={colorSampleButtonText}
                                                   style="tertiary"
                                                   className="color-specs-block__button"/>)}
            </div>
        </div>
    )
}
